import * as React from 'react';
import type { QuickChip } from '../types/assistant';

interface AssistantQuickChipsProps {
  chips: QuickChip[];
  onChipClick: (chip: QuickChip) => void;
}

const containerStyle: React.CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 6,
  padding: '4px 0 8px',
};

const chipStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 5,
  padding: '5px 12px',
  fontSize: 12,
  fontFamily: 'inherit',
  color: '#2C5282',
  background: '#fff',
  border: '1px solid #bee3f8',
  borderRadius: 16,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  transition: 'background 0.15s, border-color 0.15s',
};

export const AssistantQuickChips: React.FC<AssistantQuickChipsProps> = ({ chips, onChipClick }) => {
  if (!chips.length) return null;

  return (
    <div style={containerStyle} data-tour="didi-chips">
      {chips.map((chip, i) => (
        <button
          key={i}
          type="button"
          style={chipStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#ebf8ff';
            e.currentTarget.style.borderColor = '#90cdf4';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#fff';
            e.currentTarget.style.borderColor = '#bee3f8';
          }}
          onClick={() => onChipClick(chip)}
        >
          {chip.icon && <i className={`fas ${chip.icon}`} style={{ fontSize: 11 }} />}
          {chip.text}
        </button>
      ))}
    </div>
  );
};
